import { useDealerLaunchProgress } from 'app/pages/Header/context/DealerLaunchProgressContext';
import { shouldShowDealerLaunchMaterializationStatus } from 'utils/dealerLaunchMaterialization';

export function useDealerLaunchMaterializationStatusClick(dealer: unknown) {
  const { openProgressModal } = useDealerLaunchProgress();
  const isStatusClickable = shouldShowDealerLaunchMaterializationStatus(dealer);

  return {
    isStatusClickable,
    onStatusClick: isStatusClickable ? openProgressModal : undefined,
  };
}
